import React, { useState, useRef, useEffect, useContext } from 'react';
import { View, Text, Pressable, StyleSheet, Image, ScrollView } from 'react-native';
import MaterialCommunityIcons from "@expo/vector-icons/MaterialCommunityIcons";
import { GlobalStateContext } from '../general/GlobalStateProvider';
import { isParentAccount } from '../../interface/AccountType';

const styles = StyleSheet.create({
    container: {
        position: 'absolute' as const,
        top: 92,
        right: 550,
        zIndex: 1000,
        backgroundColor: 'white',
        width: 380,
        maxHeight: 500,
        borderRadius: 18,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 6 },
        shadowOpacity: 0.12,
        shadowRadius: 20,
        elevation: 8,
        borderWidth: 1,
        borderColor: '#E5E7EB',
        overflow: 'hidden',
    },
    header: {
        paddingHorizontal: 18,
        paddingVertical: 16,
        borderBottomWidth: 1,
        borderBottomColor: '#F3F4F6',
        backgroundColor: '#FCFCFD',
    },
    headerText: {
        fontSize: 17,
        fontWeight: '700' as const,
        color: '#111827',
    },
    section: {
        paddingHorizontal: 18,
        paddingVertical: 16,
    },
    row: {
        flexDirection: 'row' as const,
        alignItems: 'center' as const,
        justifyContent: 'space-between' as const,
    },
    sectionCard: {
        borderWidth: 1,
        borderColor: '#E5E7EB',
        borderRadius: 16,
        backgroundColor: '#FAFAFA',
        padding: 14,
    },
    sectionHeaderRow: {
        flexDirection: 'row' as const,
        alignItems: 'center' as const,
        justifyContent: 'space-between' as const,
        marginBottom: 10,
        gap: 10,
    },
    labelWrap: {
        flexDirection: 'row' as const,
        alignItems: 'center' as const,
        gap: 8,
    },
    labelIconBubble: {
        width: 28,
        height: 28,
        borderRadius: 14,
        alignItems: 'center' as const,
        justifyContent: 'center' as const,
        backgroundColor: '#E8F1EA',
    },
    label: {
        fontSize: 14,
        color: '#111827',
        fontWeight: '700' as const,
    },
    ageControls: {
        flexDirection: 'row' as const,
        alignItems: 'center' as const,
        gap: 8,
    },
    ageBadge: {
        minWidth: 68,
        height: 34,
        borderRadius: 17,
        borderWidth: 1,
        borderColor: '#D1D5DB',
        backgroundColor: '#FFFFFF',
        alignItems: 'center' as const,
        justifyContent: 'center' as const,
        paddingHorizontal: 10,
    },
    stepperBtn: {
        width: 32,
        height: 32,
        borderRadius: 16,
        borderWidth: 1,
        borderColor: '#cbd5e1',
        backgroundColor: '#f8fafc',
        alignItems: 'center' as const,
        justifyContent: 'center' as const,
    },
    stepperBtnHovered: {
        backgroundColor: '#eef2f5',
        borderColor: '#94a3b8',
    },
    ageValue: {
        fontSize: 14,
        fontWeight: '600' as const,
        width: 40,
        textAlign: 'center' as const,
        color: '#222',
    },
    chipsRow: {
        flexDirection: 'row' as const,
        flexWrap: 'nowrap' as const,
        gap: 8,
        marginTop: 8,
    },
    chip: {
        flex: 1,
        flexDirection: 'row' as const,
        alignItems: 'center' as const,
        justifyContent: 'center' as const,
        gap: 6,
        paddingHorizontal: 10,
        paddingVertical: 9,
        borderRadius: 999,
        borderWidth: 1,
        borderColor: '#cbd5e1',
        backgroundColor: '#FFFFFF',
    },
    chipActive: {
        backgroundColor: '#3C8248',
        borderColor: '#3C8248',
    },
    chipText: {
        fontSize: 13,
        color: '#111827',
        fontWeight: '500' as const,
    },
    chipTextActive: {
        color: 'white',
    },
    helperText: {
        fontSize: 11,
        color: '#6B7280',
        marginTop: 2,
    },
    footer: {
        paddingHorizontal: 18,
        paddingVertical: 14,
        borderTopWidth: 1,
        borderTopColor: '#F3F4F6',
        flexDirection: 'row' as const,
        alignItems: 'center' as const,
        justifyContent: 'space-between' as const,
        backgroundColor: '#ffffff',
    },
    clearText: {
        fontSize: 14,
        fontWeight: '600' as const,
        color: '#666',
    },
    doneBtn: {
        backgroundColor: '#3C8248',
        borderRadius: 8,
        paddingHorizontal: 14,
        paddingVertical: 8,
        alignItems: 'center' as const,
        justifyContent: 'center' as const,
    },
    doneText: {
        color: 'white',
        fontSize: 14,
        fontWeight: '600' as const,
    },
    toggleContainer: {
        flexDirection: 'row' as const,
        gap: 8,
        marginBottom: 14,
    },
    toggleButton: {
        flex: 1,
        paddingVertical: 10,
        paddingHorizontal: 12,
        borderRadius: 10,
        borderWidth: 1,
        borderColor: '#cbd5e1',
        backgroundColor: '#FFFFFF',
        alignItems: 'center' as const,
    },
    toggleButtonActive: {
        backgroundColor: '#3C8248',
        borderColor: '#3C8248',
    },
    toggleButtonText: {
        fontSize: 13,
        fontWeight: '600' as const,
        color: '#666',
    },
    toggleButtonTextActive: {
        color: 'white',
    },
    childrenScrollView: {
        maxHeight: 200,
    },
    childCard: {
        flexDirection: 'row' as const,
        alignItems: 'center' as const,
        paddingVertical: 12,
        paddingHorizontal: 12,
        borderRadius: 12,
        marginBottom: 8,
        borderWidth: 1,
        borderColor: '#E5E7EB',
        backgroundColor: '#fff',
    },
    childCardSelected: {
        backgroundColor: '#e8f5e9',
        borderColor: '#3C8248',
    },
    childAvatar: {
        width: 40,
        height: 40,
        borderRadius: 20,
        backgroundColor: '#3C8248',
        alignItems: 'center' as const,
        justifyContent: 'center' as const,
        marginRight: 12,
    },
    childAvatarImage: {
        width: 40,
        height: 40,
        borderRadius: 20,
    },
    childInitials: {
        color: 'white',
        fontSize: 16,
        fontWeight: '600' as const,
    },
    childInfo: {
        flex: 1,
    },
    childName: {
        fontSize: 14,
        fontWeight: '700' as const,
        color: '#111827',
        marginBottom: 2,
    },
    childDetails: {
        fontSize: 12,
        color: '#666',
    },
    emptyState: {
        paddingVertical: 20,
        alignItems: 'center' as const,
    },
    emptyStateText: {
        fontSize: 14,
        color: '#999',
        textAlign: 'center' as const,
    },
    divider: {
        height: 1,
        backgroundColor: '#f0f0f0',
        marginVertical: 12,
    },
});

interface CampersBoxProps {
    age: number | null;
    setAge: (age: number | null) => void;
    gender: string;
    setGender: (gender: string) => void;
    setShowCampers: (show: boolean) => void;
}

const CampersBox = ({age, setAge, gender, setGender, setShowCampers}: CampersBoxProps) => {
    const campersRef = useRef<HTMLDivElement>(null);
    const [hovered, setHovered] = useState<string | null>(null);
    const { user } = useContext(GlobalStateContext);
    
    // State for selection mode: 'child' or 'general'
    const [selectionMode, setSelectionMode] = useState<'child' | 'general'>(
        isParentAccount(user?.accountType) && user?.children && user.children.length > 0 ? 'child' : 'general'
    );
    const [selectedChildId, setSelectedChildId] = useState<string | null>(null);

    const isFamilyAccount = isParentAccount(user?.accountType);
    const hasChildren = user?.children && user.children.length > 0;

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (campersRef.current && !(campersRef.current as any).contains(event.target as Node)) {
                setShowCampers(false);
            }
        };

        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [setShowCampers]);

    const handleAgeChange = (increment: boolean) => {
        const baselineAge = typeof age === 'number' ? age : 5;
        const next = increment ? baselineAge + 1 : Math.max(1, baselineAge - 1);
        setAge(next);
    };

    const handleGenderSelect = (selectedGender: string) => {
        setGender(selectedGender);
    };

    const handleModeChange = (mode: 'child' | 'general') => {
        setSelectionMode(mode);
        // Clear selections when switching modes
        if (mode === 'child') {
            setAge(null);
            setGender('Any');
        } else {
            setSelectedChildId(null);
        }
    };

    const handleChildSelect = (childId: string) => {
        const child = user?.children?.find(c => c.childId === childId);
        if (child) {
            setSelectedChildId(childId);
            // Set age and gender from child profile for search purposes
            setAge(child.age || calculateAge(child.dateOfBirth));
            // Infer gender from name if needed, or you can add gender to ChildProfile
            setGender('Any');
        }
    };

    const handleClear = () => {
        setAge(null);
        setGender('Any');
        setSelectedChildId(null);
    };

    const getChildInitials = (firstName: string, lastName: string) => {
        return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
    };

    const calculateAge = (dateOfBirth: string) => {
        const dob = new Date(dateOfBirth);
        const today = new Date();
        let age = today.getFullYear() - dob.getFullYear();
        const monthDiff = today.getMonth() - dob.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
            age--;
        }
        return age;
    };

    return (
        <View style={styles.container} ref={campersRef as any}>
            <View style={styles.header}>
                <Text style={styles.headerText}>Attendee Preferences</Text>
            </View>

            <View style={styles.section}>
                {/* Toggle for Family Accounts */}
                {isFamilyAccount && hasChildren && (
                    <View style={styles.toggleContainer}>
                        <Pressable
                            onPress={() => handleModeChange('child')}
                            style={[styles.toggleButton, selectionMode === 'child' && styles.toggleButtonActive]}
                        >
                            <Text style={[styles.toggleButtonText, selectionMode === 'child' && styles.toggleButtonTextActive]}>
                                Saved Children
                            </Text>
                        </Pressable>
                        <Pressable
                            onPress={() => handleModeChange('general')}
                            style={[styles.toggleButton, selectionMode === 'general' && styles.toggleButtonActive]}
                        >
                            <Text style={[styles.toggleButtonText, selectionMode === 'general' && styles.toggleButtonTextActive]}>
                                Custom Search
                            </Text>
                        </Pressable>
                    </View>
                )}

                {/* Child Selection Mode */}
                {isFamilyAccount && selectionMode === 'child' && (
                    <View>
                        {hasChildren ? (
                            <ScrollView style={styles.childrenScrollView}>
                                {user.children.map((child) => (
                                    <Pressable
                                        key={child.childId}
                                        style={[
                                            styles.childCard,
                                            selectedChildId === child.childId && styles.childCardSelected
                                        ]}
                                        onPress={() => handleChildSelect(child.childId)}
                                    >
                                        <View style={styles.childAvatar}>
                                            {child.profileImage ? (
                                                <Image
                                                    source={{ uri: child.profileImage }}
                                                    style={styles.childAvatarImage}
                                                />
                                            ) : (
                                                <Text style={styles.childInitials}>
                                                    {getChildInitials(child.firstName, child.lastName)}
                                                </Text>
                                            )}
                                        </View>
                                        <View style={styles.childInfo}>
                                            <Text style={styles.childName}>
                                                {child.firstName} {child.lastName}
                                            </Text>
                                            <Text style={styles.childDetails}>
                                                Age {child.age || calculateAge(child.dateOfBirth)}
                                            </Text>
                                        </View>
                                        {selectedChildId === child.childId && (
                                            <MaterialCommunityIcons name="check-circle" size={24} color="#3C8248" />
                                        )}
                                    </Pressable>
                                ))}
                            </ScrollView>
                        ) : (
                            <View style={styles.emptyState}>
                                <Text style={styles.emptyStateText}>
                                    No children added yet.{'\n'}Add children in your profile.
                                </Text>
                            </View>
                        )}
                    </View>
                )}

                {/* General Search Mode */}
                {selectionMode === 'general' && (
                    <>
                        {/* Age */}
                        <View style={styles.sectionCard}>
                            <View style={styles.sectionHeaderRow}>
                                <View>
                                    <View style={styles.labelWrap}>
                                        <View style={styles.labelIconBubble}>
                                            <MaterialCommunityIcons name="cake-variant-outline" size={16} color="#3C8248" />
                                        </View>
                                        <Text style={styles.label}>Age</Text>
                                    </View>
                                    <Text style={styles.helperText}>Optional</Text>
                                </View>
                                <View style={styles.ageControls}>
                                    <Pressable
                                        onHoverIn={() => setHovered('minus')}
                                        onHoverOut={() => setHovered(null)}
                                        onPress={() => handleAgeChange(false)}
                                        style={[styles.stepperBtn, hovered === 'minus' && styles.stepperBtnHovered]}
                                    >
                                        <MaterialCommunityIcons name="minus" size={18} color={'#475569'} />
                                    </Pressable>
                                    <View style={styles.ageBadge}>
                                        <Text style={styles.ageValue}>{typeof age === 'number' ? age : 'Any'}</Text>
                                    </View>
                                    <Pressable
                                        onHoverIn={() => setHovered('plus')}
                                        onHoverOut={() => setHovered(null)}
                                        onPress={() => handleAgeChange(true)}
                                        style={[styles.stepperBtn, hovered === 'plus' && styles.stepperBtnHovered]}
                                    >
                                        <MaterialCommunityIcons name="plus" size={18} color={'#475569'} />
                                    </Pressable>
                                </View>
                            </View>
                        </View>

                        {/* Gender */}
                        <View style={[styles.sectionCard, { paddingTop: 14, marginTop: 12 }]}>
                            <View style={styles.labelWrap}>
                                <View style={styles.labelIconBubble}>
                                    <MaterialCommunityIcons name="account-group-outline" size={16} color="#3C8248" />
                                </View>
                                <Text style={styles.label}>Gender</Text>
                            </View>
                            <Text style={styles.helperText}>Optional</Text>
                            <View style={styles.chipsRow}>
                                <Pressable
                                    onPress={() => handleGenderSelect('Any')}
                                    onHoverIn={() => setHovered('any')}
                                    onHoverOut={() => setHovered(null)}
                                    style={[styles.chip, (gender === 'Any' || hovered === 'any') && styles.chipActive]}
                                >
                                    <MaterialCommunityIcons name="cards-outline" size={15} color={(gender === 'Any' || hovered === 'any') ? '#FFFFFF' : '#64748B'} />
                                    <Text style={[styles.chipText, (gender === 'Any' || hovered === 'any') && styles.chipTextActive]}>Any</Text>
                                </Pressable>
                                <Pressable
                                    onPress={() => handleGenderSelect('Boy')}
                                    onHoverIn={() => setHovered('boy')}
                                    onHoverOut={() => setHovered(null)}
                                    style={[styles.chip, (gender === 'Boy' || hovered === 'boy') && styles.chipActive]}
                                >
                                    <MaterialCommunityIcons name="human-male" size={15} color={(gender === 'Boy' || hovered === 'boy') ? '#FFFFFF' : '#64748B'} />
                                    <Text style={[styles.chipText, (gender === 'Boy' || hovered === 'boy') && styles.chipTextActive]}>Male</Text>
                                </Pressable>
                                <Pressable
                                    onPress={() => handleGenderSelect('Girl')}
                                    onHoverIn={() => setHovered('girl')}
                                    onHoverOut={() => setHovered(null)}
                                    style={[styles.chip, (gender === 'Girl' || hovered === 'girl') && styles.chipActive]}
                                >
                                    <MaterialCommunityIcons name="human-female" size={15} color={(gender === 'Girl' || hovered === 'girl') ? '#FFFFFF' : '#64748B'} />
                                    <Text style={[styles.chipText, (gender === 'Girl' || hovered === 'girl') && styles.chipTextActive]}>Female</Text>
                                </Pressable>
                            </View>
                        </View>
                    </>
                )}
            </View>

            {/* Footer */}
            <View style={styles.footer}>
                <Pressable onPress={handleClear}>
                    <Text style={styles.clearText}>Clear</Text>
                </Pressable>
                <Pressable style={styles.doneBtn} onPress={() => setShowCampers(false)}>
                    <Text style={styles.doneText}>Done</Text>
                </Pressable>
            </View>
        </View>
    );
};

export default CampersBox;